export default __webpack_public_path__ + "static/media/004-linux.8f43b47d.png";